<div class="pageheader">
  <div class="page-title">
    <div>
      <div class="title-container">
        <h1>Test Run Results - {{ currentTestRunDateTime() | date:'yyyy-MM-dd HH:mm:ss' }}</h1>
        <div class="btn-group">
          <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
        </div>
      </div>
      <h3>Test Case - {{currentTestCaseName()}}</h3>
    </div>
  </div>
  <div class="btn-toolbar">
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="refresh()">Refresh document statuses</button>
    </div>
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="startCompare()">Start compare</button>
    </div>
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="rerunTestRun()">Run test case again</button>
    </div>
  </div>
</div>

<dx-data-grid biz-grid [dataSource]='currentTestRunResults' [selection]='{ mode: "none"}' [bizSetColumnChooser]='true'
  [bizHideSelectedRowsComponent]='true' [showResetButton]='true' [showRefreshButton]='false' [bizSetGroupPanel]='true'
  [bizSetPager]="false" [bizSetSearchPanel]="true" [loadPanel]='{ enabled: true }' [showBorders]="true"
  (onRowDblClick)="viewFullErrorMessage($event)">

  <dxo-state-storing [enabled]="true" type="sessionStorage" [storageKey]="stateStorageKey"
    savingTimeout="500"></dxo-state-storing>
  <dxo-editing mode="row" [allowUpdating]="false" [allowAdding]="false" [allowDeleting]="false"></dxo-editing>

  <dxi-column dataField="SortOrder" caption="Result Number" dataType="number" [allowFiltering]="false"
    [allowGrouping]="false" [visible]="true"></dxi-column>
  
    <dxi-column dataField="InterchangeInIdForActual" caption="Interchange In Id" dataType="number" [allowFiltering]="true"
    [allowGrouping]="true" [visible]="true"></dxi-column>
  
    <dxi-column dataField="DocumentStatusForActual" caption="Document Status" dataType="string"
    cellTemplate="documentStatusTemplate" [allowFiltering]="true" [allowGrouping]="true" [visible]="true"></dxi-column>

  <dxi-column dataField="TestStatusText" caption="Test Status" cellTemplate="compareStatusViewTemplate" dataType="string" [allowFiltering]="true"
    [allowGrouping]="true" [visible]="true"></dxi-column>

  <dxi-column dataField="ErrorMessage" caption="Description [Double click to see full message]" dataType="string"
    [allowFiltering]="true" [allowGrouping]="true" [visible]="true"></dxi-column>

  <dxi-column dataField="AcceptedNote" caption="Accepted note" dataType="string" [allowFiltering]="true"
    [allowGrouping]="true" [visible]="false"></dxi-column>
  
    <dxi-column dataField="DocumentTypeFormatVariantVersionForActualIn"
    caption="[Actual] [In] Document Type / Format / Variant / Version" dataType="string" [allowFiltering]="true"
    [allowGrouping]="true" [visible]="false"></dxi-column>
  
    <dxi-column dataField="DocumentTypeFormatVariantVersionForActualOut"
    caption="[Actual] [Out] Document Type / Format / Variant / Version" dataType="string" [allowFiltering]="true"
    [allowGrouping]="true" [visible]="true"></dxi-column>
  
    <dxi-column dataField="DocumentLocationForActual" caption="Location" dataType="string" [allowFiltering]="true"
    [allowGrouping]="true" [visible]="true"></dxi-column>

    <dxi-column dataField="ActualPartnerInName" caption="[Actual] Partner In" dataType="string" [allowFiltering]="true"
    [allowGrouping]="true" [visible]="false"></dxi-column>
  
    <dxi-column dataField="ActualPartnerOutName" caption="[Actual] Partner Out" dataType="string" [allowFiltering]="true"
    [allowGrouping]="true" [visible]="false"></dxi-column>

    <dxi-column biz-grid-user dataField="TestRunInterchangeCreatedBy" caption="Test Run Interchange Created By"
    [visible]="false">

    <dxo-header-filter
      [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(currentTestRunResults, 'TestRunInterchangeCreatedBy'))"></dxo-header-filter>
  </dxi-column>
  
  <dxi-column biz-grid-date dataField="TestRunInterchangeCreatedDate" caption="Test Run Interchange Created Date"
    [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="TestRunDocumentCreatedBy" caption="Test Run Document Created By"
    [visible]="false">
    <dxo-header-filter
      [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(currentTestRunResults, 'TestRunDocumentCreatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="TestRunDocumentCreatedDate" caption="Test Run Document Created Date"
    [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-data dataField="TestCaseInterchangeNote" caption="Test Case Interchange Note" [visible]="true"
    dataType="string" [allowGrouping]="true" [allowFiltering]="true"></dxi-column>

  <dxi-column type="buttons" [fixed]="true" fixedPosition="right" alignment="right">
    <dxi-button text="Go to document" hint="Goes to the detail view of the actual document" [onClick]="goToDocument"
      [visible]="doesRowHaveDocumentId"></dxi-button>
    <dxi-button text="Compare" hint="Compare the expected and the actual document"
      [onClick]="goToVisualCompare"></dxi-button>
    <dxi-button text="Test Case" hint="Go to Test Case" [onClick]="viewTestCaseRowEvent"></dxi-button>
    <dxi-button text="Download test files" hint="Download all the test documents"
      [onClick]="downloadAllTestRunFiles"></dxi-button>
  </dxi-column>

  <div *dxTemplate="let cell of 'documentStatusTemplate'">
    <ep-tracking-status [currentStatus]="cell.data.DocumentStatusForActual"></ep-tracking-status>
  </div>

  <div *dxTemplate="let cell of 'compareStatusViewTemplate'">
    @switch (cell.data.TestStatusText) {
      @case ('Success') {
        <span class="text-success">{{ cell.data.TestStatusText }}</span>
      }
      @case ('Accepted') {
        <span class="text-info">{{ cell.data.TestStatusText }}</span>
      }
      @case ('Failed') {
        <span class="text-danger">{{ cell.data.TestStatusText }}</span>
      }
      @case ('Pending') {
        <span class="text-muted">{{ cell.data.TestStatusText }}</span>
      }
    }
  </div>
</dx-data-grid>